/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespContentModuleRegular_browseContentModule = {
    readonly description: string | null;
    readonly title: string | null;
    readonly photo: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedStorefrontLink_browseContentModule">;
    readonly " $refType": "SbRespContentModuleRegular_browseContentModule";
};
export type SbRespContentModuleRegular_browseContentModule$data = SbRespContentModuleRegular_browseContentModule;
export type SbRespContentModuleRegular_browseContentModule$key = {
    readonly " $data"?: SbRespContentModuleRegular_browseContentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespContentModuleRegular_browseContentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespContentModuleRegular_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "photo",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedStorefrontLink_browseContentModule"
    }
  ],
  "type": "ContentModuleRegular",
  "abstractKey": null
};
(node as any).hash = 'fee0dd1de42059f9bdbf2a63c52ae239';
export default node;
